import { Text, Button } from 'iq-blueberry'
import Img from 'components/common/Img'
import useIdentityDocument from './hook'
import './style.styl'
import FormContainer from 'components/common/FormContainer'
import { SecurityWarning } from '../../components/SecurityWarning'
import { FormTitle } from 'components/common/FormTitle'

const IdentityDocument = ({ fireboltStep, customGoBack }) => {
  const { handleButton, handleSubmit, showIframe, iframeUrl, iframeSuccess } =
    useIdentityDocument({
      fireboltStep,
      customGoBack,
    })

  return (
    <FormContainer 
      className="bbourocard-caf-image" 
      imageSrc="images/new-check-icon.svg">
      <div className="bbourocard-caf">
        {iframeSuccess ? (
          <div className="bbourocard-caf-container">
            <Img
              className="bbourocard-caf-icon"
              src="images/new-check-icon.svg"
            />
            <FormTitle 
            title="Documento já coletado"
            description="Vimos que você já enviou a foto do seu documento pra gente!" />
            <Button
              onClick={handleSubmit}
              expand="x"
              justify="center">
              Continuar
            </Button>
          </div>
        ) : showIframe ? (
          <iframe
            src={iframeUrl}
            width="100%"
            height="100%"
            title="Modal CAF"
            className="bbourocard-caf-modal"
            allow="camera"
          />
        ) : (
          <div className="bbourocard-caf-container">
            <div>
              <Img
                className="bbourocard-caf-icon"
                src="images/new-check-icon.svg"
              />
              <FormTitle 
                title="Documento de identificação" 
                description="Será necessário que você tire fotos da frente e verso do seu RG
                  ou CNH para comprovarmos sua identidade" 
                isRequiredStep />
            </div>
            <div>
              <SecurityWarning />
              <div className='bbourocard-caf-button'>
                <Button
                  onClick={handleButton}
                  expand="x"
                  justify="center">
                  Continuar
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </FormContainer>
  )
}

export default IdentityDocument
